// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__3PGvD","cell":"ColumnAccessor_cell__1mydz","firstCellAccent":"ColumnAccessor_firstCellAccent__1cUZk"};